var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.2527 8.62635C15.2527 12.286 12.286 15.2527 8.62635 15.2527C4.96672 15.2527 2 12.286 2 8.62635C2 4.96672 4.96672 2 8.62635 2C12.286 2 15.2527 4.96672 15.2527 8.62635ZM13.9664 15.4016C12.4976 16.5608 10.6428 17.2527 8.62635 17.2527C3.86215 17.2527 0 13.3906 0 8.62635C0 3.86215 3.86215 0 8.62635 0C13.3906 0 17.2527 3.86215 17.2527 8.62635C17.2527 10.6427 16.5609 12.4975 15.4017 13.9663L20.0001 18.5648L18.5649 20L13.9664 15.4016Z","fill":"#CCC7BF"}));
}

Search.defaultProps = {"viewBox":"0 0 20 20","fill":"none"};

module.exports = Search;

Search.default = Search;
